"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMegaMenuSearchTranslate = void 0;
exports.defaultMegaMenuSearchTranslate = {
    buy: 'Buy',
    rent: 'Rent',
    location: 'Locations',
    building: 'Buildings',
    emptyString: 'Search by district, street, address or building',
    placeholder: 'Keyword, district, street, address or building',
    districts: 'Districts',
    estates: 'Estates',
    phases: 'Phases',
    roads: 'Roads',
    buildings: 'Buildings',
};
